import React from "react";

import { Col, Row } from "react-bootstrap";
export default function SingleRow({ tracking }) {
  const { status, date: datetime, location } = tracking || {};

  // const formattedDate = formatter.format(date);

  let locationSet = "";
  if (location === "None" || location === "    " || location === " ") {
    locationSet = "";
  } else {
    locationSet = (
      <>
        <small>Location : {location}</small>
        <br />
      </>
    );
  }

  return (
    <Row style={{ border: "1px solid black", padding: "5px 10px" }}>
      <Col
        sm={6}
        md={4}
        lg={4}
        xl={4}
        style={{ borderRight: "1px solid black", textAlign: "center" }}
      >
        {datetime}
      </Col>
      <Col
        sm={6}
        md={8}
        lg={8}
        xl={8}
        style={{
          textAlign: "center",
          textTransform: "uppercase",
          fontWeight: "bold",
        }}
      >
        {locationSet}
        {status}
      </Col>
    </Row>
  );
}
